var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oz-toggle',{attrs:{"data-cy":"area-toggle","title":"Buscar pela área total","initialValue":_vm.initialValue},on:{"filters:update":_vm.updateTotalArea}})
}
var staticRenderFns = []

export { render, staticRenderFns }